import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface InitialCapitalDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  initialCapitalFromConfig: number;
  t: (key: string) => string;
}

const InitialCapitalDialog: React.FC<InitialCapitalDialogProps> = ({ open, onClose, onConfirm, initialCapitalFromConfig, t }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("Initial Capital from Config")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("Do you want to take the initial capital from the config file?")}
        </DialogContentText>
        <DialogContentText>
          {t("Initial Capital")}: {initialCapitalFromConfig}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t("Cancel")}
        </Button>
        <Button onClick={onConfirm} color="primary">
          {t("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InitialCapitalDialog;
